import React from "react";
import { ArrowLeft } from "lucide-react";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import DealOverview from "./DealOverview";
import Notes from "./Notes";

const DealDetails = ({ deal, onBack }) => {
  return (
    <div className="w-full bg-[var(--bg-standard)] rounded-[12px] flex flex-col gap-5">
      <div className="flex items-center gap-3 m-[1px]">
        <SecondaryButton
          icon={<ArrowLeft size={14} className="text-gray-700" />}
          onClick={onBack}
          className="!w-fit !px-1.5 !py-1.5 min-w-0"
        />
        {/* <h1 className="text-lg font-semibold text-gray-00">{deal.name}</h1> */}
      </div>
      <DealOverview deal={deal} />
      <Notes dealId={deal.id} />
    </div>
  );
};

export default DealDetails;
